import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GatemanService } from '../../services/gateman.service';
import { AppService } from '../../services/app.service'
import { NetContentPipe } from '../../pipes/net-content.pipe';
import { PageService } from '../../services/page.service';
import { MultiLangPipe } from '../../pipes/multi-lang.pipe';
import { ShortCodePipe } from '../../pipes/short-code.pipe';
import { SmartLabelService } from '../smart-label/smart-label.service';
import { PopoverController } from '@ionic/angular';
import { PopoverComponent } from '../popover/popover.component';

interface  LanguageObject {
  languageCode: string;
  value: string;
}

interface ProductHeaderConfig  {
  brandName: string | Array<LanguageObject>;
  productName: string | Array<LanguageObject>;
  netContent: Array<any>;
  productImageUrl: string;
  gtin: string;
  upc: string;
  mapping?: {
    gtinKey?: string,
    brandNameKey?: string,
    productNameKey?: string,
    upcKey?: string;
    netContentKey?: string;
    productImageUrlKey?: string,
  };
  entityInformation?: {[key: string]: any}
  tooltipText?: string;
}
@Component({
  selector: 'app-product-header',
  templateUrl: './product-header.component.html',
  styleUrls: ['./product-header.component.scss'],
  //providers: [ShortCodePipe]
})
export class ProductHeaderComponent implements OnInit {
  @Input() config: ProductHeaderConfig;
  @Input() data;
  imageLink;
  netContent: string;

  productVariants = [];
  /**
   * @author - SwapnilP
   * @task - QLIKTAG-2888
   */
  constructor(
    public popoverController: PopoverController,
    private multiLang: MultiLangPipe,
    private pageService: PageService,
    private appService: AppService,
    private gatemanService: GatemanService,
    private activatedRoute: ActivatedRoute,
    private smartlabelService: SmartLabelService,
    private shortCodePipe: ShortCodePipe) { }

  /**
   * @author - SwapnilP
   * @task - QLIKTAG-2888
   */
  ngOnInit() {

    // console.log('PRODUCT HEADER');
    // console.log(this.data, this.config);

    if (this.config.hasOwnProperty('entityInformation') && this.config.entityInformation) {
      const variants = this.config.entityInformation.productvariant;
      if (Array.isArray(variants) && variants.length) {
        this.productVariants = variants.map((item: {data: {variantDisplayId: string}}, index: number) => {
          if (item.data.hasOwnProperty('variantDisplayId') && item.data.variantDisplayId) {
            return {
              value: index,
              label: item.data.variantDisplayId
            };
          } else {
            return {
              value: index,
              label: '-'
            };
          }
        });
      }
    }

    this.imageLink = `p/${this.pageService.pageAlias}?detail=product-images`;
    let path: Array<string>;
    // Todo: Can be reduced using loop if convention is followed stricitly field => fieldKey.
    if (this.config.hasOwnProperty('mapping')) {
      if (this.config.mapping.hasOwnProperty('gtinKey')) {
        path = this.config.mapping.gtinKey.split('.');
        const gtin = this.appService.findObjectByPath(this.data, path);
        this.config.gtin = typeof gtin === 'string' ? gtin.padStart(14, '0') : '';
      }
      if (this.config.mapping.hasOwnProperty('brandNameKey')) {
        path = this.config.mapping.brandNameKey.split('.');
        this.config.brandName = this.appService.findObjectByPath(this.data, path);
      }
      if (this.config.mapping.hasOwnProperty('productNameKey')) {
        path = this.config.mapping.productNameKey.split('.');
        this.config.productName = this.appService.findObjectByPath(this.data, path);
      }
      if (this.config.mapping.hasOwnProperty('upcKey')) {
        path = this.config.mapping.upcKey.split('.');
        this.config.upc = this.appService.findObjectByPath(this.data, path);
      }
      if (this.config.mapping.hasOwnProperty('netContentKey')) {
        path = this.config.mapping.netContentKey.split('.');
        this.config.netContent = this.appService.findObjectByPath(this.data, path);
        this.netContent = this.getNetContent(this.config.netContent);
      }
      if (this.config.mapping.hasOwnProperty('productImageUrlKey')) {
        path = this.config.mapping.productImageUrlKey.split('.');
        this.config.productImageUrl = this.appService.findObjectByPath(this.data, path);
      }
    }
  }

  /**
   * [getNetContent - converts netContent list translated array to string]
   * @param  netContent [Array of type { measurementUnitCode: {} , value: 35} ]
   * @return [string 35 oz (907 g)]
   * @task - QLIKTAG-2888
   * @author - SwapnilP
   */
  getNetContent(netContent: Array<{measurementUnitCode: any, value: number}>): string {

    if(netContent && netContent.length > 0){

      return netContent.reduce((acc: string, item: any, index: number) => {
        if (index) {
          acc = `${acc} (${item.value} ${this.shortCodePipe.transform(`{{SL.data.modules.ProductQuantityInformationModuleType.netContent.${index}.measurementUnitCode | mapTo: listItemName}}`)})`;
        } else {
          acc = `${item.value} ${this.shortCodePipe.transform(`{{SL.data.modules.ProductQuantityInformationModuleType.netContent.${index}.measurementUnitCode | mapTo: listItemName}}`)}`;
        }
        return acc;
      }, '');

    } else {
      return '';
    }
  }

  /**
   * onOptionChange - Function to emit event when product variant changes
   * @param event {type: string, payload: {[key: string]: any} }
   * @author - SwapnilP
   */
  onOptionChange(event: {type: string, payload: {[key: string]: any}}) {
    if (event.type === 'smartlabel-selector') {
      this.smartlabelService.smartLabelEvents$.next(event);
      // console.log(event.payload);
    }
  }

  /**
   * showPopover - Show popover with content when user clicks on info icon near selector
   * @author- SwapnilP
   * @task - QLIKTAG-3834
   */
  showPopover(event: any) {
    let tooltipText = 'Select the appropriate variant/version number as given in the physical pack to get the exact information';
    this.popoverController.create({
      component: PopoverComponent,
      componentProps: {
        text: this.config.hasOwnProperty('tooltipText') && this.config.tooltipText != '' ? this.config.tooltipText : tooltipText
      },
      cssClass: 'variant-popover',
      mode: 'ios',
      event: event,
      showBackdrop: true,
      animated: true,
      translucent: false
    }).then(p => {
      p.present();
    });
  }
}
